import ReactDOM from "react-dom/client";
import "./index.css";

// Aplicar tema guardado antes del primer render
const savedMode = localStorage.getItem("layoutMode");
if (savedMode === "light" || savedMode === "dark") {
  document.body.setAttribute("data-bs-theme", savedMode);
  document.body.setAttribute("data-topbar", savedMode);
  document.body.setAttribute("data-sidebar", savedMode);
}
import "flatpickr/dist/flatpickr.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureAppStore } from "./store/index";
import { AuthProvider } from "@/shared/contexts/AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 3,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
    },
  },
});

const getId: any = document.getElementById("root");
const root = ReactDOM.createRoot(getId);
root.render(
  <Provider store={configureAppStore({})}>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <App />
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </Provider>
);
